import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiListModule } from "@snelstart/ui-list";
import { SharedUiLoadingModule } from "@snelstart/ui-loading";
import { SharedUiOffCanvasModule } from "@snelstart/ui-off-canvas";
import { FeatureTaxUitstelDetailsComponent } from "./tax-uitstel-details/feature-tax-uitstel-details.component";
import {UitstelComponent} from "./uitstel/uitstel.component";

@NgModule({
  imports: [
    CommonModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDialogModule,
    SharedUiListModule,
    SharedUiLoadingModule,
    SharedUiOffCanvasModule,
    UitstelComponent,
    FeatureTaxUitstelDetailsComponent
  ],
  declarations: [

  ],
  exports: [FeatureTaxUitstelDetailsComponent],
})
export class FeatureTaxUitstelDetailsModule {}
